var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: '90%', height: '100%', margin: '0 auto' }),attrs:{"id":"myChart1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }